import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';

const SEOHead = ({ title, description, ogTitle, ogDescription, ogImage, path }) => {
  const { seo } = useSiteSettings();

  const finalTitle = title || seo.site_title || 'O4S.ai';
  const finalDescription = description || seo.site_description || '';
  const finalOgTitle = ogTitle || seo.og_title || finalTitle;
  const finalOgDescription = ogDescription || seo.og_description || finalDescription;
  const finalOgImage = ogImage || seo.og_image || '';
  const url = path ? `${window.location.origin}${path}` : window.location.href;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={finalOgTitle} />
      <meta property="og:description" content={finalOgDescription} />
      <meta property="og:url" content={url} />
      {finalOgImage && <meta property="og:image" content={finalOgImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalOgTitle} />
      <meta name="twitter:description" content={finalOgDescription} />
      {finalOgImage && <meta name="twitter:image" content={finalOgImage} />}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEOHead;
